export const sortAlphabeticallyPrioritizeSigma = (a: string, b: string): number => {
  if (a.startsWith('Σ') && !b.startsWith('Σ')) {
    return -1;
  } else if (!a.startsWith('Σ') && b.startsWith('Σ')) {
    return 1;
  } else {
    return a.localeCompare(b);
  }
}